import * as React from 'react';
import CookieConsent from 'react-cookie-consent';
import { createRoot } from 'react-dom/client';
import '../fonts/material-symbols-outlined.woff2';
import '../fonts/nunito-sans-v11-latin-300.woff';
import '../fonts/nunito-sans-v11-latin-300.woff2';
import '../fonts/nunito-sans-v11-latin-regular.woff';
import '../fonts/nunito-sans-v11-latin-regular.woff2';
import '../fonts/roboto-v29-latin-700.woff';
import '../fonts/roboto-v29-latin-700.woff2';
import '../fonts/roboto-v29-latin-regular.woff';
import '../fonts/roboto-v29-latin-regular.woff2';
import '../images/favicon.ico';
import '../images/white_h_logo.png';
import '../import_template.csv';
import { ChakraProvider, Box } from '@chakra-ui/react';
import { Theme } from './Theme';
import { Pages } from './routes/Pages';
import { AuthCheck } from './ui/auth/AuthCheck';
import { system } from './theme/theme';

const mountPoint = document.getElementById('mount')!;

createRoot(mountPoint).render(
  <ChakraProvider value={system}>
    <Box className='dark' height='100%'>
      <AuthCheck>
        <React.Fragment>
          <Theme />
          <Pages />
          <CookieConsent>
            This website uses cookies to enable user experience.
          </CookieConsent>
        </React.Fragment>
      </AuthCheck>
    </Box>
  </ChakraProvider>
);
